"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _GradeTypeConstants = _interopRequireDefault(require("../../constants/GradeTypeConstants"));

/**
 * Simply wraps the appropriate classes around its children.
 */
var ResultSection =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(ResultSection, _React$Component);

  function ResultSection() {
    (0, _classCallCheck2.default)(this, ResultSection);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ResultSection).apply(this, arguments));
  }

  (0, _createClass2.default)(ResultSection, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          gradeType = _this$props.gradeType,
          children = _this$props.children;
      var classes = (0, _classnames.default)({
        'result-section': true,
        'result-section-great': gradeType === _GradeTypeConstants.default.GREAT,
        'result-section-good': gradeType === _GradeTypeConstants.default.GOOD,
        'result-section-ok': gradeType === _GradeTypeConstants.default.OK,
        'result-section-bad': gradeType === _GradeTypeConstants.default.BAD
      });
      return _react.default.createElement("div", {
        className: classes,
        "data-reagan-selector": "result-section"
      }, children);
    }
  }]);
  return ResultSection;
}(_react.default.Component);

exports.default = ResultSection;
ResultSection.propTypes = {
  gradeType: _propTypes.default.string,
  children: _propTypes.default.node
};
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/result/ResultSection.js
// module id = 52
// module chunks = 0